import { createQueryKeys } from "@lukemorales/query-key-factory";
import { ExciseLicenceRequestListPayload } from "./exciseLicences.types";

/**
 * Keys used to invalidate stored cached data regarding excise licence module
 */
export const exciseLicenceKeys = createQueryKeys("excise_licence", {
  exciseLicenceRequestList: ({
    filters,
  }: {
    filters: Partial<ExciseLicenceRequestListPayload>;
  }) => ({
    queryKey: ["excise_licence_request_list", filters],
  }),
});
